import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import ConfirmationDialog from "lib/components/dialog/ConfirmationDialog";

import useFetch from "utils/fetch/useFetch";

import { Status } from "document/StatusTypes";

import BlueprintClient from "../BlueprintClient";

export type DeleteBlueprintDialogProps = {
	ids: number[];

	onClose: () => void;
	onConfirm: () => void;
};

export default function DeleteBlueprintDialog(
	props: Readonly<DeleteBlueprintDialogProps>
): JSX.Element {
	const { t } = useTranslation();
	const { call } = useFetch();

	const handleConfirm = useCallback((): Promise<void> => {
		return Promise.all(
			props.ids.map(id =>
				call(
					BlueprintClient.updateStatus(id, {
						status: Status.DELETED
					})
				)
			)
		).then(props.onConfirm);
	}, [props.ids, props.onConfirm]);

	return (
		<ConfirmationDialog
			title={t("deleteBlueprint")}
			dialogText={t("deleteBlueprintMessage", {
				count: props.ids.length
			})}
			cancelLabel={t("cancel")}
			confirmLabel={t("delete")}
			onClose={props.onClose}
			onConfirm={handleConfirm}
		/>
	);
}
